//translations
import en_US from "./translations/en_US";

const configLabels =
{
    en_US
};

export default configLabels;